/**
 * Legal copy locale picker.
 *
 * Returns the fully-populated document for the requested locale, falling
 * back to Italian (our source of truth) for any locale that hasn't been
 * wired yet. This keeps the product safe: no blank pages, only a
 * graceful fallback to IT until Laura approves the other translations.
 */
import it from "./it";
import en from "./en";
import es from "./es";
import pt from "./pt";
import fr from "./fr";

const REGISTRY = {
    it,
    en,
    es,
    pt,
    fr,
};

const FALLBACK_LOCALE = "it";

export function getLegalCopy(locale, docKey) {
    const bundle = REGISTRY[locale] || REGISTRY[FALLBACK_LOCALE];
    const doc = bundle[docKey] || REGISTRY[FALLBACK_LOCALE][docKey];
    return doc || { preamble: [], sections: [] };
}

export function hasTranslatedLocale(locale) {
    return Boolean(REGISTRY[locale]);
}

export default getLegalCopy;
